<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel69')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('tel6')">
                                <el-input v-model="searchform.blurry" size="small" ></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('tel66')">
                                <el-select size="small" v-model="searchform.principalId" filterable :placeholder="$t('qxz')">
                                    <el-option :label="$t('qxz')" :value="null"></el-option>
                                    <el-option v-for="item in principallist"
                                        :key="item.id"
                                        :label="item.nickName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="phone" :label="$t('phone')" width="180px"></el-table-column>
                        <el-table-column prop="level" :label="$t('tel88')" width="180px">
                            <template slot-scope="scope">
                                {{scope.row.time|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('re15')" width="180px">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="userName1" :label="$t('tel89')"></el-table-column>
                        <el-table-column prop="email" :label="$t('tel90')"></el-table-column>
                        <el-table-column prop="recipient" :label="$t('tel60')"></el-table-column>
                        <el-table-column prop="type1" :label="$t('tel91')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.type1 == 0" type="success" size="mini">{{$t('tel92')}}</el-tag>
                                <el-tag v-if="scope.row.type1 == 1" type="info" size="mini">{{$t('tel93')}}</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                searchform: {
                    blurry: "",
                    idDial: "",
                    principalId:null,
                },
                total: 1,
                pageNo: 1,
                pageSize: 10,
                loading: false,
                showadd: false,
                phone:null,
                list: [],
                value1:[],
                principallist:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getprincipal()
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.succTelList, {
                    page: this.pageNo,
                    size: this.pageSize,
                    phone: this.searchform.blurry,
                    principalId:this.searchform.principalId,
                }).then(res => {
                    this.loading = false
                    this.blurry=null
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 5,
                }).then(res => {
                    this.principallist = res.content
                })
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>